export default "__VITE_ASSET__BBqNx8ZD__"